<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('order.listTitle') }}</span>
          </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('order.orderStatus')">
              <el-select v-model="formInline.state" :placeholder="$t('common.pleaseSelect')" @input="onSearch">
                <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('order.orderTime')" class="mar_l20">
              <el-date-picker v-model="formInline.timeData" type="daterange" value-format="timestamp" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch" size="medium">{{ $t('common.filter') }}</el-button>
            </el-form-item>
          </div>
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('order.orderNo')" class>
              <el-input v-model="formInline.outTradeNo" size="medium" :placeholder="$t('order.orderNoPh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.customerTel')" class="mar_l20">
              <el-input v-model="formInline.endTel" size="medium" :placeholder="$t('order.customerTelPh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.storeName')" class="mar_l20">
              <el-input v-model="formInline.storeName" size="medium" :placeholder="$t('order.storeNamePh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('order.riderName')" class>
              <el-input v-model="formInline.userName" size="medium" :placeholder="$t('order.riderNamePh')" @input="onSearch"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="ba_f mar_t20 pad_20">
        <el-table v-loading="listLoading" ::element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID" width="55"></el-table-column>
          <el-table-column prop="outTradeNo" :label="$t('order.orderNo')" min-width="180"></el-table-column>
          <el-table-column prop="state" :label="$t('order.orderStatus')" min-width="80">
            <template slot-scope="scope">
              <div class="flex" v-if="scope.row.state == 1">
                <section class="debug-d" style="background: #2a75ed;"></section>
                <span style="color: #2a75ed;">{{ orderStateLabel(1) }}</span>
              </div>
              <div class="flex" v-if="scope.row.state == 2">
                <section class="debug-d" style="background: #f56c6c;"></section>
                <span style="color: #f56c6c;">{{ orderStateLabel(2) }}</span>
              </div>
              <div class="flex" v-if="scope.row.state == 3">
                <section class="debug-d" style="background: #67c23a;"></section>
                <span style="color: #67c23a;">{{ orderStateLabel(3) }}</span>
              </div>
              <div class="flex" v-if="scope.row.state == 4">
                <section class="debug-d" style="background: #4caf50;"></section>
                <span style="color: #67c23a;">{{ orderStateLabel(4) }}</span>
              </div>
              <div class="flex" v-if="scope.row.state == 5">
                <section class="debug-d" style="background: #999;"></section>
                <span style="color: #999;">{{ orderStateLabel(5) }}</span>
              </div>
              <div class="flex" v-if="scope.row.state == 6">
                <section class="debug-d" style="background: #a40000;"></section>
                <span style="color: #a40000;">{{ orderStateLabel(6) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('order.pushTime')" min-width="150"></el-table-column>
          <el-table-column prop="orderType" :label="$t('order.orderType')" min-width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.orderType == 1">{{ $t('order.takeaway') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="storeName" :label="$t('order.orderStore')" min-width="80"></el-table-column>
          <el-table-column prop="money" :label="$t('order.orderAmount')" align="center" min-width="100"></el-table-column>
          <el-table-column prop="startDetail" :label="$t('order.startAddress')" min-width="300" align="center">
            <template slot-scope="scope">
              <div class="flex" style="text-align: left;">
                <section class="debug-d debug-trip" style="background: #2a75ed;">{{ $t('common.start') }}</section>
                <span>{{ scope.row.startDetail }}</span>
              </div>
              <div style="padding-left: 25px; text-align: left;">{{ scope.row.startTel }}</div>
              <div class="flex mar_t20">
                <section class="debug-d debug-trip" style="background: #FF8000;">{{ $t('common.end') }}</section>
                <span style="text-align: left;">{{ scope.row.endDetail }}</span>
              </div>
              <div style="padding-left: 25px;text-align: left;">{{ `${scope.row.endUsername}(${ scope.row.endTel })` }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('order.acceptRider')" min-width="130" align="center">
            <template slot-scope="scope">
              <div class="flex">
                <section v-if="scope.row.name" style="background: #2a75ed;" class="debug-d debug-small"></section>
                <span :style="{ 'text-align': scope.row.name ? 'left' : 'center',width: '100%' }">{{ scope.row.name || '--' }}</span>
              </div>
              <div class="flex" style="text-align: left;">
                <section v-if="scope.row.tel" style="background: #FF8000;" class="debug-d debug-small"></section>
                <span>{{ scope.row.tel }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('order.commission')" align="center" min-width="100">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.commission ? '#FF8000' : '#666' }">{{ scope.row.commission || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="handleSeeEdit(scope.row.id)">{{ $t('common.detail') }}</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <order-info ref="orderInfo" v-if="dialogVisible" @close="dialogVisible = false"></order-info>
  </div>
</template>
<script>
import OrderInfo from './components/order-info.vue';
import { orderList, deleteOrder } from '@/api/order';

export default {
  components: {
    OrderInfo
  },
  data() {
    return {
      dialogVisible: false,
      formInline: {
        storeName: '',
        userName: '',
        endTel: '',
        state: '0',
        timeData: [],
        storeId: '',
        outTradeNo: ''
      },
      list: [],
      listLoading: true,
      selectRows: '',
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  computed: {
    loadingText() {
      return this.$t('common.loading');
    },
    stateOptions() {
      return [
        { value: '0', label: this.$t('order.all') },
        { value: '1', label: this.$t('orderState.pending') },
        { value: '2', label: this.$t('orderState.arrive') },
        { value: '3', label: this.$t('orderState.pickup') },
        { value: '4', label: this.$t('orderState.delivering') },
        { value: '5', label: this.$t('orderState.completed') },
        { value: '6', label: this.$t('orderState.cancelled') },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleSeeEdit(id) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.orderInfo.init(id);
      });
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('order.deleteConfirm'), null, async () => {
          const { msg } = await deleteOrder({
            id: row.id
          });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    onSearch() {
      this.fetchData();
    },
    async fetchData() {
      var params = {
        page: this.page.currentPage
      };
      if (this.formInline.storeName) {
        params.storeName = this.formInline.storeName;
      }
      if (this.formInline.userName) {
        params.userName = this.formInline.userName;
      }
      if (this.formInline.endTel) {
        params.endTel = this.formInline.endTel;
      }
      if (this.formInline.state) {
        params.state = this.formInline.state;
      }
      if (this.formInline.storeId) {
        params.storeId = this.formInline.storeId;
      }
      if (this.formInline.outTradeNo) {
        params.outTradeNo = this.formInline.outTradeNo;
      }
      if (this.formInline.timeData.length > 0) {
        params.startAt = parseInt(this.formInline.timeData[0] / 1000);
        params.endAt = parseInt(this.formInline.timeData[1] / 1000);
      }

      const { data, count } = await orderList(params);
      this.page.total = count;
      this.list = data;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    }
  }
};
</script>
<style lang="scss" scoped>
.color-2c3e50 {
  color: #2c3e50;
}
.color-606266 {
  color: #606266;
}
.el-dialog__body {
  padding-top: 0;
}
.el-tabs__content {
  margin-left: 20px;
}
</style>
<style>
.dialog .el-tabs__content {
  padding-left: 25px;
}
.dialog .el-dialog__body {
  padding-top: 0;
  height: 400px;
}
</style>
